<div class="myPages">
  <ion-badge *ngFor="let item of pages; let i = index" [color]="current == i ? 'secondary' : 'primary'">
    {{ item.index + 1 }}
  </ion-badge>
</div>
